import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UrlService } from '@core/services/url.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportLayoutUiService {
  #httpClient = inject(HttpClient);
  #urlService = inject(UrlService);

  public isCurrentUserTaskApprover(projectId: string): Observable<boolean> {
    const url = this.#urlService.getUrl(`hubs/${projectId}/is-task-reviewer`);
    return this.#httpClient.get<boolean>(url);
  }
}
